import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/workspace/src/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeHeader"] */ "/workspace/src/components/home/home-header.tsx");
